import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

/** Info tab — edit name / description / topic / privacy. */
export default function InfoTab({
  name, setName, description, setDescription, topic, setTopic,
  priv, setPriv, canManage, saving, onSave,
}) {
  return (
    <div className="space-y-3 pt-1">
      <div>
        <label className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">Name</label>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={!canManage}
          data-testid="channel-settings-name"
        />
      </div>
      <div>
        <label className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">Description</label>
        <Textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
          disabled={!canManage}
          data-testid="channel-settings-description"
        />
      </div>
      <div>
        <label className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">Topic</label>
        <Input
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          placeholder="A short line describing what's currently in focus"
          disabled={!canManage}
          data-testid="channel-settings-topic"
        />
      </div>
      <label className="flex items-center gap-2 text-sm cursor-pointer select-none">
        <input
          type="checkbox"
          checked={priv}
          onChange={(e) => setPriv(e.target.checked)}
          disabled={!canManage}
          data-testid="channel-settings-private"
        />
        <span>Private channel <span className="text-zinc-400">— only invited members can see it</span></span>
      </label>
      {canManage && (
        <div className="flex justify-end pt-1">
          <Button
            onClick={onSave}
            disabled={saving}
            data-testid="channel-settings-save"
            className="bg-[var(--brand-accent)] text-white hover:bg-orange-700"
          >
            {saving ? "Saving…" : "Save changes"}
          </Button>
        </div>
      )}
    </div>
  );
}
